import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';
import {
  getImpersonatedUserId,
  getCurrentAuthToken,
} from '../Auth/AuthProvider';

let apiInstance: AxiosInstance;

export function getApiInstance() {
  if (!apiInstance) {
    // Create an Axios instance
    console.log(
      'creating API with: REACT_APP_API_URL:',
      window.env.REACT_APP_API_URL,
    );
    apiInstance = createApiInstance();
  }

  return apiInstance;
}

export function createApiInstance(params?: CreateAxiosDefaults) {
  const config = {
    // Unfortunately, we can't extract the defaults into a static const because the env is not initialized at that point
    baseURL: window.env.REACT_APP_API_URL,
    ...params,
  };

  if (!config.baseURL) {
    throw new Error(`failed to init API: Base URL is empty`);
  }

  const api = axios.create(config);

  // Axios request interceptor to attach the JWT token to every request
  api.interceptors.request.use(
    async (config) => {
      config.headers.contentType = 'application/json';
      const token = await getCurrentAuthToken();
      if (token) {
        config.headers.Authorization = `${token}`;
      }
      config.headers['Impersonated-User'] = getImpersonatedUserId();

      console.log('backend api request config: ', config);
      return config;
    },
    (error) => {
      console.log(`Error adding JWT token to request: ${error}`);
      return Promise.reject(error);
    },
  );

  return api;
}
